/**
 * assets/page-vijverfolie-op-maat.js
 * Gedrag van sections/page-vijverfolie-op-maat.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

/* Maatvoering en onderdoek-variant uit het JSON-eiland #vf-config hierboven.
   Zie ARCHITECTURE.md sectie 11. */
var VF = { minMaat: 0, onderdoek: { variantId: null, price: 0, m2PerStuk: 0, titel: '' } };
try {
  var _vfEl = document.getElementById('vf-config');
  if (_vfEl) VF = Object.assign(VF, JSON.parse(_vfEl.textContent) || {});
} catch (_e) {}

(function () {
  'use strict';
  var MIN_MAAT = VF.minMaat;
  var ONDERDOEK = {
    variantId: VF.onderdoek.variantId,
    price: VF.onderdoek.price,
    m2PerStuk: VF.onderdoek.m2PerStuk,
    titel: VF.onderdoek.titel
  };
  var state = { variantId: null, price: 0, title: '', maxL: 25, maxB: 8, l: null, b: null };

  var $ = function (id) { return document.getElementById(id); };
  var typeButtons = document.querySelectorAll('[data-vfm-type]');
  var inpL = $('vfm-lengte'), inpB = $('vfm-breedte');
  var fout = $('vfm-maat-fout'), maatOk = $('vfm-maat-ok');
  var addBtn = $('vfm-add-btn'), akkoord = $('vfm-akkoord'), addFout = $('vfm-add-fout');
  var odRow = $('vfm-onderdoek-row'), odCheck = $('vfm-onderdoek'), odLabel = $('vfm-onderdoek-label');
  var sticky = $('vfm-sticky'), stickyTotaal = $('vfm-sticky-totaal'), stickyDetail = $('vfm-sticky-detail'), stickyBtn = $('vfm-sticky-btn');

  var fmtEur = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
  var fmtM2 = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 2 });

  function parseM(el) {
    var v = (el.value || '').replace(',', '.').trim();
    if (v === '') return null;
    var n = parseFloat(v);
    return isNaN(n) ? NaN : n;
  }

  /* NPI-rolbreedte: folie bestaat uit banen van 2 m; één maat moet veelvoud van 2 m zijn*/
  function isRolMaat(x) { return Math.abs(x / 2 - Math.round(x / 2)) < 0.005; }
  function nextRolMaat(x) { return Math.ceil(x / 2 - 1e-9) * 2; }

  function deltas() {
    typeButtons.forEach(function (b) {
      var el = b.querySelector('[data-vfm-delta]');
      if (!el) return;
      var p = parseInt(b.dataset.price, 10) || 0;
      if (!state.price || b.classList.contains('is-selected') || !p) { el.textContent = ''; return; }
      var d = (p - state.price) / 100;
      el.textContent = (d > 0 ? '+' : '−') + fmtEur.format(Math.abs(d)) + '/m² t.o.v. je keuze';
    });
  }

  function selectType(btn) {
    typeButtons.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');
    state.variantId = btn.dataset.variantId;
    state.price = parseInt(btn.dataset.price, 10) || 0;
    state.title = btn.dataset.title;
    state.maxL = parseFloat(btn.dataset.maxLengte) || 25;
    state.maxB = parseFloat(btn.dataset.maxBreedte) || 8;
    deltas();
    render(true);
  }

  function getErrors() {
    var errs = [];
    if (state.l !== null && (isNaN(state.l) || state.l < MIN_MAAT)) errs.push({ el: inpL, msg: 'Lengte moet minimaal ' + String(MIN_MAAT).replace('.', ',') + ' m zijn.' });
    if (state.b !== null && (isNaN(state.b) || state.b < MIN_MAAT)) errs.push({ el: inpB, msg: 'Breedte moet minimaal ' + String(MIN_MAAT).replace('.', ',') + ' m zijn.' });
    if (state.variantId) {
      if (state.l > state.maxL) errs.push({ el: inpL, msg: 'Maximale lengte voor dit folietype is ' + String(state.maxL).replace('.', ',') + ' m. Grotere maat nodig? App ons via WhatsApp.' });
      if (state.b > state.maxB) errs.push({ el: inpB, msg: 'Maximale breedte voor dit folietype is ' + String(state.maxB).replace('.', ',') + ' m. Grotere maat nodig? App ons via WhatsApp.' });
    }
    return errs;
  }

  function showErrors(errs) {
    [inpL, inpB].forEach(function (el) { el.classList.remove('is-invalid'); });
    errs.forEach(function (e) { e.el.classList.add('is-invalid'); });
    fout.textContent = errs.map(function (e) { return e.msg; }).join(' ');
    fout.classList.toggle('hidden', errs.length === 0);
  }

  function calc() {
    if (!state.variantId || state.l === null || state.b === null || isNaN(state.l) || isNaN(state.b)) return null;
    if (getErrors().length) return null;
    if (!(isRolMaat(state.l) || isRolMaat(state.b))) return null;
    var exact = state.l * state.b;
    var billed = Math.ceil(exact - 1e-9);
    var odQty = ONDERDOEK.variantId && odCheck && odCheck.checked ? Math.ceil(billed / ONDERDOEK.m2PerStuk) : 0;
    return { exact: exact, billed: billed, folie: billed * state.price, onderdoek: odQty * ONDERDOEK.price, odQty: odQty, total: billed * state.price + odQty * ONDERDOEK.price };
  }

  var rolFix = $('vfm-rol-fix'), fix1 = $('vfm-fix-1'), fix2 = $('vfm-fix-2');
  var rolOpties = null;
  function updateRolFix() {
    var show = state.variantId && state.l > 0 && state.b > 0 && !isNaN(state.l) && !isNaN(state.b) &&
      state.l >= MIN_MAAT && state.b >= MIN_MAAT && state.l <= state.maxL && state.b <= state.maxB &&
      !(isRolMaat(state.l) || isRolMaat(state.b));
    if (!show) { rolFix.classList.add('hidden'); rolOpties = null; return; }
    var lUp = nextRolMaat(state.l), bUp = nextRolMaat(state.b);
    var extraL = (lUp - state.l) * state.b, extraB = state.l * (bUp - state.b);
    var optL = { dim: 'l', val: lUp, label: 'Maak lengte ' + String(lUp).replace('.', ',') + ' m (+' + fmtM2.format(extraL) + ' m²)' };
    var optB = { dim: 'b', val: bUp, label: 'Maak breedte ' + String(bUp).replace('.', ',') + ' m (+' + fmtM2.format(extraB) + ' m²)' };
    rolOpties = extraL <= extraB ? [optL, optB] : [optB, optL];
    fix1.textContent = rolOpties[0].label;
    fix2.textContent = rolOpties[1].label;
    rolFix.classList.remove('hidden');
  }
  function applyRolFix(i) {
    if (!rolOpties) return;
    var o = rolOpties[i];
    var el = o.dim === 'l' ? inpL : inpB;
    el.value = String(o.val).replace('.', ',');
    state.l = parseM(inpL); state.b = parseM(inpB);
    render(true);
  }

  /* showFeedback=true: toon fouten (na blur/typekeuze); false: alleen prijs/positief bijwerken*/
  function render(showFeedback) {
    if (showFeedback) showErrors(getErrors());
    updateRolFix();
    var c = calc();
    $('vfm-r-type').textContent = state.title || '—';
    $('vfm-r-prijs-m2').textContent = state.price ? fmtEur.format(state.price / 100) : '—';
    $('vfm-r-maat').textContent = (state.l && state.b && !isNaN(state.l) && !isNaN(state.b)) ? fmtM2.format(state.l) + ' × ' + fmtM2.format(state.b) + ' m' : '—';
    if (c) {
      $('vfm-r-m2').textContent = fmtM2.format(c.exact) + ' m²' + (c.billed !== c.exact ? ' (afgerond ' + c.billed + ' m²)' : '');
      $('vfm-r-totaal').textContent = fmtEur.format(c.total / 100);
      maatOk.textContent = '✓ Deze maat kunnen wij leveren, je betaalt ' + c.billed + ' m²';
      maatOk.classList.remove('hidden');
      fout.classList.add('hidden');
      [inpL, inpB].forEach(function (el) { el.classList.remove('is-invalid'); });
      if (odRow) {
        odRow.classList.remove('hidden');
        odRow.classList.add('flex');
        var q = Math.ceil(c.billed / ONDERDOEK.m2PerStuk);
        odLabel.textContent = q + '× ' + ONDERDOEK.titel + ' voor ' + fmtEur.format(q * ONDERDOEK.price / 100) + '. Beschermt je folie tegen steentjes en wortels.';
      }
    } else {
      $('vfm-r-m2').textContent = '—';
      $('vfm-r-totaal').textContent = '—';
      maatOk.classList.add('hidden');
      if (odRow) { odRow.classList.add('hidden'); odRow.classList.remove('flex'); }
    }
    addBtn.disabled = !(c && akkoord.checked);
    /* Sticky mobiele balk*/
    if (c) {
      stickyTotaal.textContent = fmtEur.format(c.total / 100);
      stickyDetail.textContent = state.title + ' · ' + fmtM2.format(state.l) + ' × ' + fmtM2.format(state.b) + ' m' + (c.odQty ? ' + onderdoek' : '');
      sticky.classList.add('is-visible');
    } else {
      sticky.classList.remove('is-visible');
    }
  }

  typeButtons.forEach(function (btn) { btn.addEventListener('click', function () { selectType(btn); }); });

  [inpL, inpB].forEach(function (el) {
    el.addEventListener('input', function () {
      state.l = parseM(inpL);
      state.b = parseM(inpB);
      render(false);
    });
    el.addEventListener('blur', function () {
      state.l = parseM(inpL);
      state.b = parseM(inpB);
      render(true);
    });
  });
  akkoord.addEventListener('change', function () { render(false); });
  fix1.addEventListener('click', function () { applyRolFix(0); });
  fix2.addEventListener('click', function () { applyRolFix(1); });
  if (odCheck) odCheck.addEventListener('change', function () { render(false); });

  /* Rekenhulp*/
  var vl = $('vfm-vl'), vb = $('vfm-vb'), vd = $('vfm-vd');
  var hulpUit = $('vfm-hulp-uitkomst'), hulpBtn = $('vfm-hulp-overnemen');
  var hulp = { l: null, b: null };
  function hulpCalc() {
    var l = parseM(vl), b = parseM(vb), d = parseM(vd);
    if (l > 0 && b > 0 && d >= 0) {
      hulp.l = Math.round((l + 2 * d + 1) * 10) / 10;
      hulp.b = Math.round((b + 2 * d + 1) * 10) / 10;
      if (!(isRolMaat(hulp.l) || isRolMaat(hulp.b))) {
        var hl = nextRolMaat(hulp.l), hb = nextRolMaat(hulp.b);
        if ((hl - hulp.l) * hulp.b <= hulp.l * (hb - hulp.b)) hulp.l = hl; else hulp.b = hb;
      }
      hulpUit.textContent = fmtM2.format(hulp.l) + ' × ' + fmtM2.format(hulp.b) + ' m (rolbreedte verwerkt)';
      hulpBtn.classList.remove('hidden');
    } else {
      hulp.l = hulp.b = null;
      hulpUit.textContent = '—';
      hulpBtn.classList.add('hidden');
    }
  }
  [vl, vb, vd].forEach(function (el) { el.addEventListener('input', hulpCalc); });
  hulpBtn.addEventListener('click', function () {
    if (hulp.l === null) return;
    inpL.value = String(hulp.l).replace('.', ',');
    inpB.value = String(hulp.b).replace('.', ',');
    state.l = hulp.l; state.b = hulp.b;
    render(true);
    inpL.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* Toevoegen aan winkelwagen*/
  function addToCart() {
    if (VF.gepauzeerd) return; /* maatwerk tijdelijk niet leverbaar */
    var c = calc();
    if (!c) return;
    if (!akkoord.checked) {
      $('vfm-prijsblok').scrollIntoView({ behavior: 'smooth', block: 'center' });
      var lbl = $('vfm-akkoord-label');
      lbl.classList.add('vfm-attention');
      setTimeout(function () { lbl.classList.remove('vfm-attention'); }, 2200);
      return;
    }
    addBtn.disabled = true;
    addBtn.textContent = 'Bezig…';
    stickyBtn.disabled = true;
    addFout.classList.add('hidden');
    var items = [{
      id: parseInt(state.variantId, 10),
      quantity: c.billed,
      properties: {
        'Folietype': state.title,
        'Lengte': String(state.l).replace('.', ',') + ' m',
        'Breedte': String(state.b).replace('.', ',') + ' m',
        'Oppervlakte': fmtM2.format(c.exact) + ' m² (afgerond ' + c.billed + ' m²)',
        '_maatwerk': 'ja'
      }
    }];
    if (c.odQty > 0) items.push({ id: ONDERDOEK.variantId, quantity: c.odQty });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add-to-cart failed');
      window.location.href = '/cart';
    }).catch(function () {
      addBtn.disabled = false;
      addBtn.textContent = 'In winkelwagen';
      stickyBtn.disabled = false;
      addFout.textContent = 'Er ging iets mis bij het toevoegen. Probeer het opnieuw of neem contact met ons op.';
      addFout.classList.remove('hidden');
    });
  }
  addBtn.addEventListener('click', addToCart);
  stickyBtn.addEventListener('click', addToCart);

  /* Preselecteer middelste (of eerste) type*/
  if (typeButtons.length) selectType(typeButtons[Math.min(1, typeButtons.length - 1)]);

  /* Prefill vanuit de vijver-calculator via URL-parameters (fl = folie-lengte, fb = folie-breedte)*/
  (function () {
    try {
      if (!inpL || !inpB) return;
      var params = new URLSearchParams(window.location.search);
      var rawL = params.get("fl"), rawB = params.get("fb");
      if (rawL === null || rawB === null) return;
      var nL = parseFloat(String(rawL).replace(",", "."));
      var nB = parseFloat(String(rawB).replace(",", "."));
      if (!isFinite(nL) || !isFinite(nB) || nL <= 0 || nB <= 0) return;
      /* De velden verwachten nl-notatie met een komma als decimaalteken*/
      inpL.value = String(nL).replace(".", ",");
      inpB.value = String(nB).replace(".", ",");
      /* Trigger de bestaande render-/validatielogica*/
      inpL.dispatchEvent(new Event("input", { bubbles: true }));
      inpB.dispatchEvent(new Event("input", { bubbles: true }));
      var note = $("vfm-prefill-note");
      if (note) note.classList.remove("hidden");
      /* Scroll de tool netjes in beeld, met wat offset voor de sticky header*/
      if (typeof inpL.scrollIntoView === "function") {
        window.setTimeout(function () {
          var y = inpL.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: y < 0 ? 0 : y, behavior: "smooth" });
        }, 120);
      }
    } catch (e) { /* stil falen: prefill is optioneel */ }
  })();
})();
